import { DocumentVersion } from "@models";
import { InsertDriveFileOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";

const NoPreview = ({
  file,
  message = "Download available from top right menu.",
}: {
  file: DocumentVersion["file"];
  message?: string;
}) => {
  if (!file) return null;

  return (
    <div className="flex justify-start flex-col p-4 gap-5 h-full">
      <div className="p-16 w-full flex justify-center items-center flex-col object-contain gap-4">
        <InsertDriveFileOutlined className="text-[8rem] opacity-20" />
        <div className="flex flex-col gap-2">
          <Typography
            fontWeight={500}
            className="opacity-30"
            variant="h2"
            textAlign="center"
            lineHeight={1.5}
          >
            Preview unavailable.
          </Typography>
          <Typography
            fontSize={16}
            className="opacity-30"
            variant="subtitle1"
            textAlign="center"
            lineHeight={1.5}
          >
            {message}
          </Typography>
        </div>
      </div>
      <div className="flex flex-col">
        <Typography fontWeight={500}>{file.filename}</Typography>
      </div>
      <div className="flex pb-1 gap-2 justify-between border-0 border-b border-solid border-gray-300">
        <span className="text-sm text-gray-500">Created at</span>
        <span className="text-sm ">
          {file.createdAt && new Date(file.createdAt).toUTCString()}
        </span>
      </div>
      <div className="flex pb-1 gap-2 justify-between border-0 border-b border-solid border-gray-300">
        <span className="text-sm text-gray-500">Updated at</span>
        <span className="text-sm ">
          {file.updatedAt && new Date(file.updatedAt).toUTCString()}
        </span>
      </div>
    </div>
  );
};

export default NoPreview;
